import { GroupedTransactionStatusEnum } from "@repo/core/constants/transactions";

export const filterStatusOptions = [
  { label: "Todas", value: "all" },
  { label: "Concluidas", value: GroupedTransactionStatusEnum.CONCLUIDO },
  { label: "Pendentes", value: GroupedTransactionStatusEnum.PENDENTE },
  { label: "Canceladas", value: GroupedTransactionStatusEnum.CANCELADO }
];
